import { render, staticRenderFns } from "./AuthButton.vue?vue&type=template&id=9ce2bf50&scoped=true&"
import script from "./AuthButton.vue?vue&type=script&lang=ts&"
export * from "./AuthButton.vue?vue&type=script&lang=ts&"
import style0 from "./AuthButton.vue?vue&type=style&index=0&id=9ce2bf50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce2bf50",
  null
  
)

export default component.exports